exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".p{overflow:hidden;white-space:nowrap;text-overflow:ellipsis}.el-carousel__item h3{font-size:18px;opacity:.75;line-height:300px;margin:0}.el-carousel__item:nth-child(2n){background-color:#99a9bf}.el-carousel__item:nth-child(odd){background-color:#d3dce6}.time{font-size:13px}.bottom{margin-top:13px;line-height:12px}.button{padding:0;float:right}.image{width:100%;display:block}.clearfix:after,.clearfix:before{display:table;content:\"\"}.clearfix:after{clear:both}", ""]);

// exports
